import {showErrorNotification, showSuccessNotification} from "../../../global/notifications";

// The Cancel Request confirmation window is identical across every capex request type -
// only the endpoint base URL and the window element differ. See general-kendo-window.js,
// computer-kendo-window.js and vehicle-kendo-window.js for the per-type wiring.
export default function createCapexCancelWindow({baseUrl, windowSelector}) {
    let _k_window = null;
    const _id = $('[data-id]').data('id');

    const deleteRequest = () => {
        return new Promise((resolve, reject) => {
            const requestData = {
                requestNumber: _id
            }
            $.post(`${baseUrl}/CancelRequest`, requestData, function (response) {
                if (response.success) {
                    window.location.href = '/Finance/CapitalExpenditures/Requests';
                    resolve(response.message);
                } else {
                    reject(response.message);
                }
            }).fail(function () {
                reject('An error occurred while processing your request.');
            })
        })
    }

    const toggleButtonActive = (enable) => {
        $('button.js-keep-confirm').prop('disabled', !enable);
        $('button.js-delete-confirmed').prop('disabled', !enable);
    }

    const attachOpenWindowEvent = () => {
        const $deleteButton = $('button.js-delete-request');

        $deleteButton.click(() => {
            toggleButtonActive(true);
            _k_window.open();
        })
    }

    const attachDeleteConfirmationEvent = () => {
        $('button.js-delete-confirmed').click(() => {
            toggleButtonActive(false);

            deleteRequest()
                .then(message => showSuccessNotification(message))
                .catch(error => showErrorNotification(error))
                .finally(_ => {
                    toggleButtonActive(true);
                    _k_window.close()
                });

        })
    }

    const attachKeepConfirmationEvent = () => {
        $('button.js-keep-confirm').click(() => {
            _k_window.close();
        })
    }

    const attachEvents = () => {
        attachOpenWindowEvent();
        attachKeepConfirmationEvent();
        attachDeleteConfirmationEvent();
    }

    const createKendoWindow = () => {
        if (_k_window !== null) return;
        const $window = $(windowSelector);
        _k_window = $window.kendoWindow({
            title: "Cancel Request Confirmation",
            visible: false,
            actions: [
                "Close"
            ],
            width: "90%",
            height: "90%",
            maxWidth: 1080,
            maxHeight: 800,
        }).data("kendoWindow").center();
    }

    return function () {
        createKendoWindow();
        attachEvents();
    }
}
